module.exports = __webpack_public_path__ + "img/color_blue.ef4f6183.svg";